"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var resource_1 = require("../shared/resource");
var SurchargeTemplate = /** @class */ (function (_super) {
    __extends(SurchargeTemplate, _super);
    function SurchargeTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.positive = false;
        _this.loading = false;
        _this.kind = 'invoice'; // invoice or scaleticket
        _this.kindTitle = 'Billing';
        return _this;
    }
    SurchargeTemplate.prototype.filterOptions = function (options) {
        options = lodash_1.clone(options);
        return options;
    };
    SurchargeTemplate.prototype.url = function (action) {
        return '/surcharge-templates/' + this.id + '/' + action;
    };
    return SurchargeTemplate;
}(resource_1.Resource));
exports.SurchargeTemplate = SurchargeTemplate;
